<template>
  <div class="create-account" :disabled="loading">
    <div class="title">{{ $tr('vacancy.settings.talentq.create-acc') }}</div>
    <div class="field">
      <div class="sub-title">{{ $tr('login.placeholders.login') }}</div>
      <vinput
        v-model="login"
        class="input"
        type="text"
        :placeholder="$tr('vacancy.settings.talentq.login-placeholder')"/>
    </div>
    <div class="field">
      <div class="sub-title">{{ $tr('login.placeholders.password') }}</div>
      <vinput
        v-model="password"
        class="input"
        type="password"
        :placeholder="$tr('vacancy.settings.talentq.password-placeholder')"/>
    </div>
    <vbutton
      class="button"
      :label="$tr('common.create_acc')"
      :loading="loading"
      @click="$emit('create', account)"/>
  </div>
</template>

<script>
  export default {
    name: "account-new-view",
    props: {
      loading: {
        type: Boolean,
        default: false,
      }
    },
    data () {
      return {
        login: '',
        password: '',
      }
    },
    computed: {
      account() {
        return {
          login: this.login,
          password: this.password
        }
      }
    }
  }
</script>
<style scoped lang="scss">
.create-account {
  margin: 15px 0;
  max-width: 280px;
  .title {
    margin: 15px 0;
    font-weight: 500;
  }
  .field {
    margin: 10px 0;
  }
  .sub-title {
    margin: 5px 0;
  }
  .input {
    margin: 5px 0;
  }
  .button {
    margin: 10px 0;
  }
}
</style>